module.exports = __webpack_public_path__ + "static/media/profileAvatar.d0a2c740.jpg";